import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Form, Input, Layout, Divider, Button, message } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { loginStart, loginSuccess, loginFailure } from "../../redux/userSlice";
import auth from "../../services/auth";
import AuthLayout from "../../components/layout/AuthLayout";
import AuthSideContent from "./../../components/layout/AuthSideContent";
import "./index.css";
import { UnlockOutlined } from "@ant-design/icons";

const { Content } = Layout;

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [msgApi, contextHolder] = message.useMessage();

  useEffect(() => {
    const tokenAlready = localStorage.getItem("token");
    if (tokenAlready) {
      navigate("/dashboard");
    }
  }, [navigate]);

  const handleFormSubmit = async (values) => {
    setLoading(true);
    dispatch(loginStart());

    try {
      // If this is the forgot password form, send POST to /forgot-password
      if (window.location.pathname === "/forgot-password") {
        const response = await fetch("/forgot-password", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: values.email }),
        });
        const data = await response.json();
        if (response.ok) {
          setLoading(false);
          msgApi.success(data.message || "Reset link sent.");
        } else {
          setLoading(false);
          msgApi.error(data.message || "Failed to send reset link.");
        }
        return;
      }
      // Otherwise, normal login
      const response = await auth.login(values);
      if (response && response.data && response.data.token) {
        setLoading(false);
        const token = response.data.token;
        localStorage.setItem("token", token);
        const previousUrl = location?.state?.prevUrl;
        const dashboardUrl = "/dashboard";
        navigate(previousUrl ? previousUrl : dashboardUrl);
        dispatch(loginSuccess(response.data));
        msgApi.success("Login successful");
      } else {
        setLoading(false);
        dispatch(loginFailure());
        msgApi.error("Login failed. Please check your credentials.");
      }
    } catch (error) {
      console.log(error);
      const errorMsg =
        error?.response?.data?.message || "Login failed. Please try again.";
      setLoading(false);
      dispatch(loginFailure());
      msgApi.error(errorMsg);
    }
  };
  return (
    <AuthLayout sideContent={<AuthSideContent />}>
      {contextHolder}
      <Content
        style={{
          padding: "200px 30px 30px",
          maxWidth: "440px",
          margin: "0 auto",
          height: "100vh",
        }}
      >
        <h1>Sign in</h1>
        <Divider />
        <Form
          layout="vertical"
          onFinish={handleFormSubmit}
          initialValues={{
            remember: true,
          }}
        >
          <Form.Item name="email" rules={[{ required: true }]}>
            <Input size="large" placeholder="Email Address" />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true }]}>
            <Input type="password" size="large" placeholder="Password" />
          </Form.Item>

          <Button
            loading={loading}
            size="large"
            className="btn-blue login-form-button"
            htmlType="submit"
            type="primary"
            block
          >
            Login
          </Button>
          <div style={{ marginTop: 16, textAlign: "right" }}>
            <a href="/forgot-password">
              <UnlockOutlined /> Forgot password?
            </a>
          </div>
        </Form>
      </Content>
    </AuthLayout>
  );
};

export default Login;
